import React from 'react';
// import logo from './logo.svg';
import BusinessList from '../BusinessList/BusinessList';
import SearchBar from '../SearchBar/SearchBar';
// import Business from '../Business/Business' ;
import './App.css';
import Yelp from "../../util/Yelp";


class App extends React.Component{
  constructor(){
    super();
    this.state={
      businesses:[]
    }
    this.searchYelp=this.searchYelp.bind(this);
  }
  searchYelp(term,location,sortBy){
    Yelp.search(term,location,sortBy).then( businesses => {this.setState({
        businesses:businesses
      })}
    )
  }
  render(){
    return (
      <div className="App">
        <h1>ravenous</h1>
        <SearchBar searchYelp={this.searchYelp} />
        <BusinessList businesses={this.state.businesses} />
      </div>
    );
  }
}

export default App;
